export default "__VITE_ASSET__7ade4eea__"